import styled from '@emotion/styled'
import { faArrowsRotate, faChevronLeft, faChevronRight } from '@fortawesome/pro-solid-svg-icons'
import { dateAndDow } from '@fusion-advantage/formlib'
import { faCalendarDays } from '@fortawesome/pro-regular-svg-icons'
import { L1PlainIconButton } from '../../../form/l1/L1Button'
import { FusionColor } from '../../../../theme/FusionStyle'
import { DateTime } from 'luxon'

const V2L2ApptListNavBarRoot = styled.div(({theme}) => ({
	display: 'grid',
	gridTemplateColumns: 'max-content 1fr max-content',
	backgroundColor: theme.colors.second,
	alignItems: 'center',
	padding: '.75rem 1rem',
	fontSize: '14px',
}))

const BarInfo = styled.div(({theme}) => ({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	justifyContent: 'center',
	...theme.fonts.titleBold,
	textTransform: 'uppercase',
	gap: '.5rem',
}))

interface V2L2ApptListNavBarProps {
	displayDate: string
	canGoPrev: boolean
	canGoNext: boolean
	onMoveDaysClick: (days: number) => void
}

export const V2L2ApptListNavBar = ({ displayDate, canGoPrev, canGoNext, onMoveDaysClick }: V2L2ApptListNavBarProps) => {
	return (
		<V2L2ApptListNavBarRoot>
			<div>
				<L1PlainIconButton
					icon={faChevronLeft}
					color={canGoPrev ? FusionColor.BlueMain : FusionColor.Transparent}
					onClick={(canGoPrev) ? () => onMoveDaysClick(-1) : undefined}
				/>
			</div>
			<BarInfo>
				<L1PlainIconButton icon={faCalendarDays} color={FusionColor.BlueMain} />
				{dateAndDow(DateTime.fromISO(displayDate))}
				{/*
					20251019 move force refresh button to sync dialog
					<L1PlainIconButton icon={faArrowsRotate} color={FusionColor.BlueMain} onClick={onRefreshClick} />
				*/}
			</BarInfo>
			<div>
				<L1PlainIconButton
					icon={faChevronRight}
					color={canGoNext ? FusionColor.BlueMain : FusionColor.Transparent}
					onClick={(canGoNext) ? () => onMoveDaysClick(1) : undefined}
				/>
			</div>
		</V2L2ApptListNavBarRoot>
	)
}
